/* global __webpack_public_path__ */
// The builder runs on ohmaworld.com but its files are served from Netlify (customize.ohmaworld.com, or
// the preview site). Point webpack's lazy-loaded chunks (like the analytics script) at wherever this
// bundle itself came from, instead of the page's own domain where they don't exist.
try {
  const src = document.currentScript && document.currentScript.src
  if (src && /\/static\/js\/[^/]+$/.test(src)) {
    // eslint-disable-next-line no-global-assign
    __webpack_public_path__ = src.replace(/static\/js\/[^/]+$/, '')
  }
} catch (e) {}
